var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { kareoHomepage } from 'constants/externalRoutes';
import { OpenInNewTab } from 'shared/assets/icons';
import { Button, Icon, Link, Text } from 'shared/components';
export var OpenKareoNoteStatus = function () {
    return (_jsx(Link, __assign({ href: kareoHomepage, target: "_blank", rel: "noopener noreferrer", variant: "unstyled", role: "group", _hover: { textDecor: 'none' } }, { children: _jsxs(Button, __assign({ variant: "links", color: "gray.600", p: 0, m: 0 }, { children: [_jsx(Text, __assign({ mr: 2 }, { children: "Open Kareo" })), _jsx(Icon, { boxSize: 3, as: OpenInNewTab, color: "gray.400", transitionTimingFunction: "ease-in-out", transitionProperty: "color", transitionDuration: "fast", _groupHover: { color: 'green.500' } })] })) })));
};
